import axios from 'axios'
import { SERVICE_URL } from './api'
import { authorizationHelper } from '../common/helpers'

function createFormData(imgV, imgH, body) {
    const data = new FormData();

    if (imgV) data.append('photos', imgV, 'vertical_img')
    if (imgH) data.append('photos', imgH, 'horizontal_img')

    Object.keys(body).forEach(key => {
        data.append(key, body[key]);
    });

    return data;
};

export function getAll(page, filter, categoryId) {
    const params = {
        page,
        filter,
        category_id: categoryId
    }

    return axios.get(SERVICE_URL, {
        params,
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function get(id) {
    const url = `${SERVICE_URL}/${id}`

    return axios.get(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}

export function create(service, imgV, imgH) {
    return axios.post(
        SERVICE_URL,
        createFormData(imgV, imgH, service),
        { headers: { 'Authorization': authorizationHelper.getAuthorizationToken() } }
    )
}

export function update(id, imgV, imgH, service) {
    const url = `${SERVICE_URL}/${id}`

    return axios.put(
        url,
        createFormData(imgV, imgH, service),
        { headers: { 'Authorization': authorizationHelper.getAuthorizationToken() } }
    )
}

export function deleteService(id) {
    const url = `${SERVICE_URL}/${id}`

    return axios.delete(url, {
        headers: { 'Authorization': authorizationHelper.getAuthorizationToken() }
    })
}


// WEBPACK FOOTER //
// ./src/service/service.js